class CCArtFilter extends HTMLElement {
  connectedCallback() {
    this.onClick = (event) => {
      const link = event.target.closest('a');
      if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const target = new URL(link.href);
      const current = new URL(location.href);
      for (const [key, value] of current.searchParams) {
        if (key.startsWith('filter.') || key === 'sort_by') target.searchParams.append(key, value);
      }
      target.searchParams.set('filter.v.availability', '1');
      this.update(target, true, link.textContent.trim());
    };
    this.onPopState = () => {
      const handle = location.pathname.split('/').filter(Boolean).at(-1);
      if (['japanska-ar-sar', 'japanska-art-rares', 'japanska-sar'].includes(handle)) this.update(new URL(location.href), false);
    };
    this.addEventListener('click', this.onClick);
    window.addEventListener('popstate', this.onPopState);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('popstate', this.onPopState);
    this.controller?.abort();
  }
  async update(url, push, label) {
    this.controller?.abort();
    const controller = this.controller = new AbortController();
    const main = document.querySelector('main');
    const search = main.querySelector('cc-collection-search input')?.value || '';
    const status = this.querySelector('[role="status"]');
    main.setAttribute('aria-busy', 'true');
    status.textContent = 'Uppdaterar produkter…';
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Products unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = doc.querySelector('main');
      if (!incoming?.querySelector('cc-art-filter') || !incoming.querySelector('.cc-collection')) throw new Error('Collection unavailable');
      if (controller.signal.aborted) return;
      const children = [...incoming.childNodes].map(node => document.importNode(node, true));
      if (push) history.pushState({}, '', url);
      document.title = doc.title;
      main.replaceChildren(...children);
      const nextSearch = main.querySelector('cc-collection-search');
      if (search && nextSearch) {
        nextSearch.querySelector('input').value = search;
        nextSearch.run();
      }
      const filter = main.querySelector('cc-art-filter');
      filter.querySelector('[role="status"]').textContent = 'Produkterna har uppdaterats.';
      if (label) [...filter.querySelectorAll('a')].find(link => link.textContent.trim() === label)?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = 'Produkterna kunde inte uppdateras. Försök igen.';
    } finally {
      if (this.controller === controller) main.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('cc-art-filter')) customElements.define('cc-art-filter', CCArtFilter);
